module.exports = __webpack_public_path__ + "img/Intranet_Head_old.8b97a1db.png";